import styled from 'styled-components';
import { Button } from '../button/button.component.js';

const layoutBySize = ({ size }) => {
    switch (size) {
        case 'small':
            return `
        height: 32px;
        width: 32px;
        padding: 8px;
      `;
        case 'large':
            return `
        height: 48px;
        width: 48px;
        padding: 8px;
      `;
        case 'medium':
        default:
            return `
        height: 40px;
        width: 40px;
        padding: 8px;
      `;
    }
};
const StyledButton = styled(Button) `
  ${layoutBySize}
`;

export { StyledButton };
